import * as React from "react"
import { createRoot } from "react-dom/client"
import { SessionContext } from "@digits-shared/components/Contexts/SessionContext"
import { StylesContextProvider } from "@digits-shared/components/Contexts/StylesContextProvider"
import { DigitsBrowserRouter } from "@digits-shared/components/Router/DigitsRouter"
import { addDeviceClasses } from "@digits-shared/helpers/devicesHelper"
import { Theme } from "@digits-shared/themes"
import colors from "@digits-shared/themes/colors"
import { enableMapSet, setAutoFreeze } from "immer"
import { GlobalStyles } from "src/shared/initializers/global"
import { AdminClient } from "src/admin/components/Client"
import routes from "src/admin/routes"
import AdminSession from "src/admin/session/AdminSession"
import "digits-shared/static/css/fonts.css"

// Ensure device classes are on <html> before React renders, so :root.desktop
// styles from GlobalStyles apply on the first paint. Relying solely on the
// transitive side-effect in globalStyles.ts is fragile in prod builds where
// chunk evaluation order can differ.
addDeviceClasses()

const session = new AdminSession()

enableMapSet()
// Need to unfreeze immer objects, so that we can still use history, or other objects being pass in effects
// can still be used anywhere in the app
setAutoFreeze(false)

const Entry: React.FC = () => (
  <SessionContext.Provider value={session}>
    <StylesContextProvider mode={Theme.Dark}>
      <GlobalStyles moduleLoadingColor={colors.white} />
      <DigitsBrowserRouter routes={routes}>
        <AdminClient />
      </DigitsBrowserRouter>
    </StylesContextProvider>
  </SessionContext.Provider>
)

const container = document.getElementById("main")
const root = createRoot(container || document.createDocumentFragment())

root.render(<Entry />)
